/* ============================================================
   FIND MY SIZE - logique
   ------------------------------------------------------------
   Toute la configuration (tranches de poids, tailles du produit)
   vient du <script type="application/json" data-size-finder-config>
   genere par snippets/product-size-finder.liquid. Ce fichier ne
   contient AUCUNE donnee de taille : il ne fait que l'appliquer.

   Les ecouteurs sont delegues sur document : le panneau continue
   de fonctionner meme si Shopify re-genere le bloc produit apres
   un changement de taille (les scripts inline, eux, ne seraient
   pas rejoues).
   ============================================================ */
(function () {
  'use strict';

  if (window.sizeFinderInstalled) return;
  window.sizeFinderInstalled = true;

  var KG_PER_LB = 0.45359237;
  var CM_PER_FT = 30.48;
  var CM_PER_IN = 2.54;

  /* ------------------------------------------------------------
     PHRASES AFFICHEES
     Un .js n'est pas interprete par Liquid : le filtre | t n'y
     fonctionne pas. Les phrases ci-dessous ne sont donc que des
     SECOURS. Le texte reellement affiche arrive dans le JSON de
     configuration (cle "text"), que snippets/product-size-finder.liquid
     remplit depuis locales/ -> donc traduisible depuis
     Parametres > Langues > Traduire et adapter.
     Pour modifier une phrase : locales/en.default.json,
     cles ttwn.size_finder.result_*, pas ici.
     ------------------------------------------------------------ */
  var TEXT = {
    recommend: 'We recommend',
    or: 'or',
    largest: 'This is our largest size in this piece.',
    soldOut: '{size} is out of stock right now.',
    below: 'You are just under our size range — this is our smallest size.',
    above: 'You are just over our size range — get in touch and we will help you.',
    pick: 'Tap a size to select it.',
    oversizedTooLong: 'At your height a size up would sit too long, so we are keeping this one.'
  };

  /* ============================================================
     MEMOIRE DES REPONSES
     Taille / poids / fit / unites sont conservees dans le navigateur
     DU CLIENT (localStorage) : il ne saisit qu'une fois pour toute la
     boutique. Ces donnees ne quittent jamais son appareil, elles ne
     sont ni envoyees au serveur ni transmises a un outil de mesure.
     ============================================================ */

  var STORAGE_KEY = 'ttwn.sizeFinder';

  function loadAnswers() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function saveAnswers(data) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      /* navigation privee, stockage refuse : on continue sans memoire. */
    }
  }

  /* ============================================================
     MESURE D'AUDIENCE - INERTE PAR DEFAUT
     L'evenement est simplement publie sur le bus d'evenements de
     Shopify. Tant qu'aucun pixel n'y est abonne (Parametres >
     Evenements client), il ne part NULLE PART et ne touche a rien :
     aucun appel a Meta, Google ou quoi que ce soit d'autre.
     Aucun risque pour le pixel existant.
     On n'envoie QUE : produit, fit choisi, taille conseillee, taille
     cliquee. Jamais la taille ni le poids du client.
     ============================================================ */

  function track(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) {}

    try {
      /* Permet aussi a n'importe quel script du theme de reagir. */
      document.dispatchEvent(new CustomEvent(name, { detail: payload }));
    } catch (e) {}
  }

  /* ---------- utilitaires ---------- */

  function config(root) {
    if (root.sizeFinderConfig) return root.sizeFinderConfig;
    var node = root.querySelector('[data-size-finder-config]');
    if (!node) return null;
    try {
      root.sizeFinderConfig = JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
    // Les phrases traduites livrees par Liquid remplacent les secours.
    var livrees = root.sizeFinderConfig.text;
    if (livrees) {
      for (var cle in livrees) {
        if (livrees[cle]) TEXT[cle] = livrees[cle];
      }
    }
    return root.sizeFinderConfig;
  }

  function num(root, field) {
    var input = root.querySelector('[data-field="' + field + '"]');
    if (!input) return NaN;
    var v = parseFloat(input.value);
    return isNaN(v) ? NaN : v;
  }

  function isMetric(root) {
    var active = root.querySelector('.size-finder__unit.is-active');
    return !active || active.dataset.unit === 'metric';
  }

  /* Tailles du produit pour lesquelles une tranche de poids existe,
     dans l'ordre reel du produit. */
  function usableSizes(cfg) {
    return (cfg.sizes || []).filter(function (s) {
      var r = cfg.ranges && cfg.ranges[s.name];
      return Array.isArray(r) && r.length === 2;
    });
  }

  /* ---------- le calcul ---------- */

  /* ------------------------------------------------------------------
     RAPPEL : LE POIDS N'EST PAS CORRIGE PAR LA TAILLE.
     Il est compare tel quel aux tranches. Si tu lis le contraire
     quelque part, c'est une vieille documentation (corrigee le
     15/10/2026 dans snippets/product-size-finder.liquid).
     ------------------------------------------------------------------
     DEUX CONTRAINTES INDEPENDANTES, ON GARDE LA PLUS EXIGEANTE
     ------------------------------------------------------------------
     Un vetement doit etre assez grand SUR LES DEUX DIMENSIONS :

       1. LA CARRURE  -> donnee par le poids (table de tranches).
       2. LA LONGUEUR -> donnee par la taille en cm, et par elle seule.

     La longueur est une contrainte PLANCHER : ce hoodie est coupe
     court, donc a partir d'1m80 le S ne tombe plus correctement, quel
     que soit le poids du client. Aucun poids ne peut rattraper ca.

     La taille conseillee est donc le MAXIMUM des deux exigences.

     C'est ce modele qui elimine definitivement le probleme precedent :
     le plancher ne fait que monter avec la taille en cm, et la carrure
     ne depend pas de la taille du tout. A poids egal, quelqu'un de plus
     petit ne peut donc jamais recevoir une taille plus grande.
     ------------------------------------------------------------------ */

  /* Rang de la plus petite taille acceptable compte tenu de la longueur. */
  function heightFloorIndex(cfg, sizes, heightCm) {
    var floor = 0;
    if (!cfg.minHeight || isNaN(heightCm) || heightCm <= 0) return floor;

    sizes.forEach(function (size, i) {
      var seuil = cfg.minHeight[size.name];
      if (typeof seuil === 'number' && heightCm >= seuil && i > floor) floor = i;
    });
    return floor;
  }

  function recommend(cfg, weightKg, heightCm, fit) {
    var sizes = usableSizes(cfg);
    if (sizes.length < 2) return null;


    var first = sizes[0];
    var last = sizes[sizes.length - 1];
    var notes = [];
    var picked;

    /* La plus petite et la plus grande taille du produit absorbent une
       marge au-dela de leur tranche : les tables de tranches restent
       ainsi propres et identiques d'un produit a l'autre, sans avoir a
       "etirer" a la main la derniere taille de chaque produit.
       Au-dela de cette marge, on le dit honnetement au client. */
    var MARGIN_LOW = 10;   // kg sous la plus petite taille
    var MARGIN_HIGH = 15;  // kg au-dessus de la plus grande

    var lowest = cfg.ranges[first.name][0];
    var highest = cfg.ranges[last.name][1];

    if (weightKg < lowest - MARGIN_LOW) {
      picked = [first];
      notes.push(TEXT.below);
    } else if (weightKg > highest + MARGIN_HIGH) {
      picked = [last];
      notes.push(TEXT.above);
    } else if (weightKg < lowest) {
      picked = [first];
    } else if (weightKg > highest) {
      picked = [last];
    } else {
      /* Tranches jointives : borne basse incluse, borne haute exclue.
         Un poids ne peut donc tomber que dans UNE seule taille.
         La derniere taille inclut sa borne haute, sinon le poids
         maximal exact ne correspondrait a rien. */
      picked = sizes.filter(function (s, i) {
        var r = cfg.ranges[s.name];
        var isLast = i === sizes.length - 1;
        return weightKg >= r[0] && (isLast ? weightKg <= r[1] : weightKg < r[1]);
      });
      if (!picked.length) picked = [first];
    }

    /* Une seule taille conseillee, toujours. */
    var index = sizes.indexOf(picked[0]);

    /* ETAPE 1 - contrainte de longueur : on ne descend jamais en dessous
       du plancher impose par la taille en cm. */
    var floorIndex = heightFloorIndex(cfg, sizes, heightCm);
    var pousseParLaLongueur = floorIndex > index;
    if (pousseParLaLongueur) index = floorIndex;

    /* ETAPE 2 - "Oversized" = EXACTEMENT une taille au-dessus du
       resultat ci-dessus. L'ordre compte : si on decalait AVANT
       d'appliquer le plancher, celui-ci pouvait rattraper le decalage
       et renvoyer la meme taille pour les deux fits (cas 185 cm/65 kg :
       la carrure donnait S, le plancher remontait a M, et l'Oversized
       partait de S pour arriver a M lui aussi). */
    var dejaLaPlusGrande = false;
    var oversizedRefuse = false;
    if (fit === 'oversized') {
      if (index >= sizes.length - 1) {
        dejaLaPlusGrande = true;
      } else {
        /* Une taille au-dessus, c'est aussi plus long. On ne la
           conseille que si le client est assez grand pour la porter :
           cfg.oversizeMinHeight donne, par taille, la stature minimale.
           Voir le tableau sf_oversize_min_height dans
           snippets/product-size-finder.liquid. */
        var cible = sizes[index + 1];
        var seuilOversize = cfg.oversizeMinHeight && cfg.oversizeMinHeight[cible.name];
        if (typeof seuilOversize === 'number' && heightCm < seuilOversize) {
          oversizedRefuse = true;
        } else {
          index = index + 1;
        }
      }
    }

    var out = [sizes[index]];

    if (dejaLaPlusGrande) notes.push(TEXT.largest);
    if (oversizedRefuse) notes.push(TEXT.oversizedTooLong);

    /* PLUS DE COMMENTAIRE SUR LA MORPHOLOGIE.
       Les deux phrases qui tenaient ici ("Taller build...",
       "Shorter build...") commentaient le corps du client. La taille
       saisie sert toujours au calcul - c'est elle qui impose le
       plancher de longueur, voir heightFloorIndex - mais elle ne
       donne plus lieu a un commentaire affiche.
       cfg.heightTall et cfg.heightShort ne servent donc plus a rien
       dans ce fichier ; ils restent dans product-size-finder.liquid
       au cas ou tu voudrais revenir en arriere. */

    out.forEach(function (s) {
      if (!s.available) notes.push(TEXT.soldOut.replace('{size}', s.name));
    });

    /* Phrase propre au produit (cfg.note, definie par famille dans
       snippets/product-size-finder.liquid) : "ce polo taille une taille
       en dessous", "coupe longue"... Elle passe en TETE des remarques,
       c'est la plus utile au client. */
    if (cfg.note) notes.unshift(cfg.note);

    return { sizes: out, notes: notes };
  }

  /* ---------- affichage ---------- */

  function render(root) {
    var box = root.querySelector('[data-size-finder-result]');
    var cfg = config(root);
    if (!box || !cfg) return;

    var metric = isMetric(root);
    var weightKg = metric ? num(root, 'weight-kg') : num(root, 'weight-lb') * KG_PER_LB;

    var heightCm;
    if (metric) {
      heightCm = num(root, 'height-cm');
    } else {
      var ft = num(root, 'height-ft');
      var inch = num(root, 'height-in');
      if (isNaN(ft)) heightCm = NaN;
      else heightCm = ft * CM_PER_FT + (isNaN(inch) ? 0 : inch) * CM_PER_IN;
    }

    var fitButton = root.querySelector('.size-finder__fit.is-active');
    var fit = fitButton ? fitButton.dataset.fit : null;

    /* Produits dont la coupe ne se discute pas (askFit a faux dans
       snippets/product-size-finder.liquid) : la question n'est pas
       posee, on raisonne donc sur le porte ajuste, c'est-a-dire les
       tranches telles qu'elles sont ecrites. */
    if (cfg.askFit === false) fit = 'fitted';

    /* On n'affiche rien tant que les reponses attendues ne sont pas la. */
    if (isNaN(weightKg) || weightKg <= 0 || isNaN(heightCm) || heightCm <= 0 || !fit) {
      box.hidden = true;
      box.innerHTML = '';
      return;
    }

    var result = recommend(cfg, weightKg, heightCm, fit);
    if (!result) {
      box.hidden = true;
      return;
    }

    var html = '<p class="size-finder__result-label">' + TEXT.recommend + '</p>';
    html += '<div class="size-finder__result-sizes">';
    result.sizes.forEach(function (s, i) {
      if (i > 0) html += '<span class="size-finder__or">' + TEXT.or + '</span>';
      html +=
        '<button type="button" class="size-finder__size' +
        (s.available ? '' : ' size-finder__size--unavailable') +
        '" data-size-pick="' +
        s.name.replace(/"/g, '&quot;') +
        '"' +
        (s.available ? '' : ' disabled') +
        '>' +
        s.name +
        '</button>';
    });
    html += '</div>';

    var notes = result.notes.slice();
    if (result.sizes.some(function (s) { return s.available; })) notes.push(TEXT.pick);
    notes.forEach(function (n) {
      html += '<p class="size-finder__note">' + n + '</p>';
    });

    box.innerHTML = html;
    box.hidden = false;

    /* On retient les reponses pour les autres fiches produit. */
    saveAnswers({
      unit: metric ? 'metric' : 'imperial',
      heightCm: Math.round(heightCm),
      weightKg: Math.round(weightKg * 10) / 10,
      fit: fit
    });

    /* Un seul evenement par resultat distinct, sinon chaque frappe au
       clavier en declencherait un. */
    var signature = fit + ':' + result.sizes.map(function (s) { return s.name; }).join(',');
    if (root.lastTracked !== signature) {
      root.lastTracked = signature;
      track('size_finder_result', {
        product_id: cfg.productId,
        product_type: cfg.productType,
        fit: fit,
        recommended: result.sizes.map(function (s) { return s.name; }).join(',')
      });
    }
  }

  /* Re-remplit les champs avec ce que le client a deja saisi ailleurs. */
  function restoreAnswers(root) {
    if (root.answersRestored) return;
    root.answersRestored = true;

    var saved = loadAnswers();
    /* On se fie a la taille en cm et non au fit : sur un produit qui ne
       pose pas la question de la coupe, le fit n'est pas forcement en
       memoire, et les champs resteraient vides. */
    if (!saved || !saved.heightCm) return;

    if (saved.unit === 'imperial') switchUnits(root, 'imperial');

    var metric = saved.unit !== 'imperial';
    if (metric) {
      var hCm = root.querySelector('[data-field="height-cm"]');
      var wKg = root.querySelector('[data-field="weight-kg"]');
      if (hCm && saved.heightCm) hCm.value = saved.heightCm;
      if (wKg && saved.weightKg) wKg.value = Math.round(saved.weightKg);
    } else {
      var totalIn = saved.heightCm / CM_PER_IN;
      var hFt = root.querySelector('[data-field="height-ft"]');
      var hIn = root.querySelector('[data-field="height-in"]');
      var wLb = root.querySelector('[data-field="weight-lb"]');
      if (hFt && saved.heightCm) hFt.value = Math.floor(totalIn / 12);
      if (hIn && saved.heightCm) hIn.value = Math.round(totalIn % 12);
      if (wLb && saved.weightKg) wLb.value = Math.round(saved.weightKg / KG_PER_LB);
    }

    root.querySelectorAll('.size-finder__fit').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.fit === saved.fit);
    });

    render(root);
  }

  /* ---------- ouverture / fermeture ---------- */

  function backdrop(root) {
    var el = root.querySelector('.size-finder__backdrop');
    if (!el) {
      el = document.createElement('button');
      el.type = 'button';
      el.className = 'size-finder__backdrop';
      el.setAttribute('aria-label', 'Close');
      el.hidden = true;
      root.appendChild(el);
    }
    return el;
  }

  /* ============================================================
     FRONTIERE D'EVENEMENTS
     ------------------------------------------------------------
     Le guide est pose DANS le <legend> du selecteur de variantes
     (voir snippets/product-variant-picker.liquid). Les evenements de
     ses champs remontaient donc jusqu'a <variant-selects>, qui y
     voyait un changement de taille : il re-generait tout le bloc
     produit - le panneau disparaissait en pleine saisie - et, plus
     grave, il SELECTIONNAIT une taille au passage (l'adresse de la
     page se terminait par ?variant=...). Taper sa taille choisissait
     donc un article a l'insu du client.

     On arrete donc input et change a la sortie du guide. Comme nos
     propres ecouteurs sont delegues sur document, c'est-a-dire
     au-dessus, la saisie est traitee ici avant d'etre arretee.

     Ce que l'on n'arrete PAS : le "change" envoye sur la vraie case
     de taille quand le client clique sur la taille conseillee (voir
     selectSize). Cette case est hors du guide, l'evenement n'est donc
     jamais concerne - et c'est bien lui qui doit remonter. */
  function poserFrontiere(root) {
    if (root.dataset.frontierePosee) return;
    root.dataset.frontierePosee = '1';

    root.addEventListener('input', function (event) {
      var input = event.target.closest && event.target.closest('.size-finder__input');
      if (input) traiterSaisie(input);
      event.stopPropagation();
    });

    root.addEventListener('change', function (event) {
      event.stopPropagation();
    });
  }

  function setOpen(root, open) {
    var trigger = root.querySelector('.size-finder__trigger');
    var panel = root.querySelector('.size-finder__panel');
    if (!trigger || !panel) return;

    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    backdrop(root).hidden = !open;

    if (open) {
      var cfg = config(root);
      if (cfg && usableSizes(cfg).length < 2) {
        /* Aucune tranche utilisable pour ce produit : on masque le bouton
           plutot que d'afficher un outil qui ne peut rien conseiller. */
        root.hidden = true;
        return;
      }
      restoreAnswers(root);

      track('size_finder_opened', {
        product_id: cfg ? cfg.productId : null,
        product_type: cfg ? cfg.productType : null
      });

      var firstInput = panel.querySelector(
        '.size-finder__inputs:not([hidden]) .size-finder__input'
      );
      if (firstInput && !firstInput.value && window.innerWidth >= 750) firstInput.focus();
    }
  }

  function closeAll(except) {
    document.querySelectorAll('[data-size-finder]').forEach(function (root) {
      poserFrontiere(root);
      if (root !== except) setOpen(root, false);
    });
  }

  /* ---------- conversion des unites ---------- */

  function switchUnits(root, unit) {
    var metric = unit === 'metric';

    var hCm = root.querySelector('[data-field="height-cm"]');
    var hFt = root.querySelector('[data-field="height-ft"]');
    var hIn = root.querySelector('[data-field="height-in"]');
    var wKg = root.querySelector('[data-field="weight-kg"]');
    var wLb = root.querySelector('[data-field="weight-lb"]');

    /* On convertit ce qui est deja saisi pour ne rien faire perdre. */
    if (metric) {
      var ft = parseFloat(hFt && hFt.value);
      if (!isNaN(ft)) {
        var inch = parseFloat(hIn && hIn.value);
        hCm.value = Math.round(ft * CM_PER_FT + (isNaN(inch) ? 0 : inch) * CM_PER_IN);
      }
      var lb = parseFloat(wLb && wLb.value);
      if (!isNaN(lb)) wKg.value = Math.round(lb * KG_PER_LB);
    } else {
      var cm = parseFloat(hCm && hCm.value);
      if (!isNaN(cm)) {
        var totalIn = cm / CM_PER_IN;
        hFt.value = Math.floor(totalIn / 12);
        hIn.value = Math.round(totalIn % 12);
      }
      var kg = parseFloat(wKg && wKg.value);
      if (!isNaN(kg)) wLb.value = Math.round(kg / KG_PER_LB);
    }

    root.querySelectorAll('.size-finder__unit').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.unit === unit);
    });
    root.querySelectorAll('[data-unit-group]').forEach(function (g) {
      g.hidden = g.dataset.unitGroup !== unit;
    });

    render(root);
  }

  /* ---------- selection de la taille dans la fiche produit ---------- */

  function selectSize(root, name) {
    var cfg = config(root);
    var fitButton = root.querySelector('.size-finder__fit.is-active');

    track('size_finder_size_selected', {
      product_id: cfg ? cfg.productId : null,
      product_type: cfg ? cfg.productType : null,
      fit: fitButton ? fitButton.dataset.fit : null,
      size: name
    });

    var container = root.closest('product-info') || document;
    var inputs = container.querySelectorAll('.product-form__input input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === name && !inputs[i].disabled) {
        inputs[i].checked = true;
        inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
        setOpen(root, false);
        return;
      }
    }
    var select = container.querySelector('.product-form__input select');
    if (select) {
      select.value = name;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      setOpen(root, false);
    }
  }

  /* ---------- ecouteurs delegues ---------- */

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;

    var trigger = t.closest('.size-finder__trigger');
    if (trigger) {
      var root = trigger.closest('[data-size-finder]');
      var wasOpen = trigger.getAttribute('aria-expanded') === 'true';
      closeAll(root);
      setOpen(root, !wasOpen);
      return;
    }

    if (t.closest('.size-finder__backdrop') || t.closest('.size-finder__close')) {
      closeAll();
      return;
    }

    var unit = t.closest('.size-finder__unit');
    if (unit) {
      switchUnits(unit.closest('[data-size-finder]'), unit.dataset.unit);
      return;
    }

    var fit = t.closest('.size-finder__fit');
    if (fit) {
      var fitRoot = fit.closest('[data-size-finder]');
      fitRoot.querySelectorAll('.size-finder__fit').forEach(function (b) {
        b.classList.toggle('is-active', b === fit);
      });
      render(fitRoot);
      return;
    }

    var pick = t.closest('[data-size-pick]');
    if (pick && !pick.disabled) {
      selectSize(pick.closest('[data-size-finder]'), pick.dataset.sizePick);
      return;
    }

    /* Clic en dehors : on ferme. */
    if (!t.closest('[data-size-finder]')) closeAll();
  });

  /* ------------------------------------------------------------------
     CURSEUR TOUJOURS EN FIN DE TEXTE
     Selon le navigateur et la facon dont le champ prend le focus (clic,
     tabulation, focus provoque a l'ouverture), le curseur se placait
     parfois AVANT le texte deja saisi : il fallait alors un second clic
     pour aller corriger le dernier chiffre.
     On le repositionne donc systematiquement a la fin quand le focus
     ENTRE dans le champ. focusin ne se declenche qu'a l'entree : une
     fois dedans, l'utilisateur peut toujours cliquer ou il veut pour
     corriger un chiffre au milieu.
     ------------------------------------------------------------------ */
  document.addEventListener('focusin', function (event) {
    var input = event.target.closest && event.target.closest('.size-finder__input');
    if (!input) return;

    /* On repasse derriere le navigateur, qui place son curseur juste
       apres le focus. setTimeout plutot que requestAnimationFrame :
       ce dernier est suspendu quand l'onglet n'est pas au premier plan,
       le repositionnement ne se serait pas fait au retour sur l'onglet. */
    setTimeout(function () {
      /* On n'abandonne que si le focus est parti sur un AUTRE champ de
         l'outil entre-temps. (Tester "activeElement === input" serait
         trop strict : selon le contexte, la fenetre peut ne pas avoir
         le focus systeme alors que le champ est bien celui vise.) */
      var actif = document.activeElement;
      if (actif && actif !== input && actif.classList &&
          actif.classList.contains('size-finder__input')) return;

      /* On ne touche a rien si du texte est selectionne (l'utilisateur
         est peut-etre en train de faire un glisser pour tout remplacer). */
      if (input.selectionStart !== input.selectionEnd) return;

      var fin = input.value.length;
      try { input.setSelectionRange(fin, fin); } catch (e) {}
    }, 0);
  });

  function traiterSaisie(input) {
    /* Les champs sont en type="text" (et non "number") pour qu'aucune
       molette ni fleche ne puisse modifier la valeur par accident :
       on n'accepte donc que des chiffres, saisis au clavier. */
    var clean = input.value.replace(/[^0-9]/g, '');
    if (clean !== input.value) {
      var pos = Math.max(0, input.selectionStart - (input.value.length - clean.length));
      input.value = clean;
      try { input.setSelectionRange(pos, pos); } catch (e) {}
    }

    render(input.closest('[data-size-finder]'));
  }

  /* Filet pour un guide pose ailleurs que dans le selecteur de
     variantes : la frontiere posee par poserFrontiere() arrete
     l'evenement avant qu'il n'arrive ici, donc ces deux chemins ne se
     declenchent jamais tous les deux. */
  document.addEventListener('input', function (event) {
    var input = event.target.closest && event.target.closest('.size-finder__input');
    if (input) traiterSaisie(input);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });
})();
